import { mutationOptions, queryOptions } from "../client.ts";
import type { SubmitTrialReasonRequest } from "../types.ts";

export function toSubmitTrialReasonBody(featureName: string): SubmitTrialReasonRequest {
    return { featureName };
}

export function submitTrialReasonMutationOptions() {
    return mutationOptions("post", "/bff/onboarding/trial-reason", {
        networkMode: "always",
        onSuccess: (_data, _variables, _onMutateResult, { client }) => {
            void client.invalidateQueries({ queryKey: queryOptions("get", "/bff/session").queryKey });
        }
    });
}
